import React from "react";
import { HeadingOne } from "Common/Custom/HeadingOne";
import { UserCheck, UserX } from "lucide-react";

const AttendanceDashboardHeader = ({ stats }) => {
    return (
        <div className="d-flex justify-content-between align-items-center w-100 flex-wrap gap-3">
            <div className="d-flex align-items-center gap-2">
                <HeadingOne className="mb-0">Attendance Dashboard</HeadingOne>
            </div>
            <div className="d-flex align-items-center gap-3 ms-md-auto">
                <div className="d-flex gap-2">
                    <div className="stats-mini-card px-3 py-2 rounded-4 bg-white shadow-sm border d-flex align-items-center gap-2">
                        <div className="rounded-circle bg-success bg-opacity-10 p-2 d-flex align-items-center justify-content-center">
                            <UserCheck size={18} className="text-success" />
                        </div>
                        <div>
                            <div className="text-muted small fw-medium">Present</div>
                            <div className="h5 mb-0 fw-bold text-success">{stats.present}</div>
                        </div>
                    </div>
                    <div className="stats-mini-card px-3 py-2 rounded-4 bg-white shadow-sm border d-flex align-items-center gap-2">
                        <div className="rounded-circle bg-danger bg-opacity-10 p-2 d-flex align-items-center justify-content-center">
                            <UserX size={18} className="text-danger" />
                        </div>
                        <div>
                            <div className="text-muted small fw-medium">Absent</div>
                            <div className="h5 mb-0 fw-bold text-danger">{stats.absent}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AttendanceDashboardHeader;
